export interface BursaEvent {
  id: string;
  title: string;
  category: string;
  categoryColor: string;
  date: string;
  dayShort: string;
  dayNum: string;
  month: string;
  time: string;
  location: string;
  district: string;
  image: string;
  price: string;
  isFree: boolean;
  isFeatured: boolean;
  description: string;
  tags: string[];
}

export const weeklyEvents: BursaEvent[] = [
  {
    id: "e1",
    title: "Osmanlı Tarihi Yürüyüş Turu",
    category: "Kültür & Tarih",
    categoryColor: "bg-amber-100 text-amber-700",
    date: "2026-03-30",
    dayShort: "Pzt",
    dayNum: "30",
    month: "Mart",
    time: "10:00",
    location: "Ulu Cami Önü",
    district: "Osmangazi",
    image: "https://public.readdy.ai/ai/img_res/9560c2a86992ce076eb6ec719ca569a7.jpg",
    price: "Ücretsiz",
    isFree: true,
    isFeatured: true,
    description: "Profesyonel rehber eşliğinde Osmanlı başkentinin izlerini süren 3 saatlik tarihi yürüyüş turu.",
    tags: ["Tur", "Rehber", "Yürüyüş"],
  },
  {
    id: "e2",
    title: "Cumalıkızık Pazar Şenliği",
    category: "Pazar & Fuar",
    categoryColor: "bg-emerald-100 text-emerald-700",
    date: "2026-04-01",
    dayShort: "Çrş",
    dayNum: "1",
    month: "Nisan",
    time: "08:00 – 17:00",
    location: "Cumalıkızık Köy Meydanı",
    district: "Yıldırım",
    image: "https://readdy.ai/api/search-image?query=traditional%20village%20market%20fair%20Cumalikizik%20Bursa%20Turkey%20organic%20products%20locals%20artisan%20crafts%20stone%20houses%20morning%20atmosphere&width=600&height=380&seq=ev02&orientation=landscape",
    price: "Ücretsiz",
    isFree: true,
    isFeatured: true,
    description: "Organik köy ürünleri, el sanatları ve geleneksel Bursa lezzetleri bir arada. Her hafta Çarşamba.",
    tags: ["Pazar", "Organik", "El Sanatları"],
  },
  {
    id: "e3",
    title: "Bursa Gastronomi Günleri",
    category: "Yemek & İçecek",
    categoryColor: "bg-red-100 text-red-700",
    date: "2026-04-02",
    dayShort: "Prş",
    dayNum: "2",
    month: "Nisan",
    time: "12:00 – 22:00",
    location: "Kültür Parkı Açık Hava Alanı",
    district: "Osmangazi",
    image: "https://readdy.ai/api/search-image?query=food%20festival%20outdoor%20gastronomy%20event%20Bursa%20Turkey%20traditional%20cuisine%20tasting%20stalls%20people%20eating%20lively%20atmosphere%20colorful%20tents&width=600&height=380&seq=ev03&orientation=landscape",
    price: "30 ₺",
    isFree: false,
    isFeatured: true,
    description: "Bursa'nın en iyi restoranlarından 40+ stand. İskender, pideli köfte, kuzu çevirme ve daha fazlası.",
    tags: ["Festival", "Yemek", "Tatma"],
  },
  {
    id: "e4",
    title: "Uludağ Bahar Yürüyüşü",
    category: "Doğa & Spor",
    categoryColor: "bg-green-100 text-green-700",
    date: "2026-04-03",
    dayShort: "Cum",
    dayNum: "3",
    month: "Nisan",
    time: "07:30",
    location: "Uludağ Milli Parkı Giriş",
    district: "Osmangazi",
    image: "https://readdy.ai/api/search-image?query=spring%20hiking%20Uludag%20mountain%20Bursa%20Turkey%20group%20trekking%20forest%20green%20valley%20panoramic%20view%20athletic%20outdoor%20adventure&width=600&height=380&seq=ev04&orientation=landscape",
    price: "Ücretsiz",
    isFree: true,
    isFeatured: false,
    description: "Doğaseverler için 12 km'lik bahar yürüyüşü. Tecrübeli rehber eşliğinde orman ve yüksek ova parkuru.",
    tags: ["Yürüyüş", "Doğa", "Spor"],
  },
  {
    id: "e5",
    title: "Bursa Fotoğraf Festivali",
    category: "Sanat & Kültür",
    categoryColor: "bg-violet-100 text-violet-700",
    date: "2026-04-04",
    dayShort: "Cmt",
    dayNum: "4",
    month: "Nisan",
    time: "10:00 – 20:00",
    location: "Bursa Kültür Merkezi",
    district: "Osmangazi",
    image: "https://readdy.ai/api/search-image?query=photography%20exhibition%20gallery%20art%20culture%20event%20Bursa%20Turkey%20modern%20interior%20wall%20prints%20visitors%20elegant%20creative%20atmosphere&width=600&height=380&seq=ev05&orientation=landscape",
    price: "25 ₺",
    isFree: false,
    isFeatured: true,
    description: "50 fotoğrafçının 200+ eseri. Bursa'yı konu alan özgün kareler ve panel konuşmaları.",
    tags: ["Sanat", "Fotoğraf", "Sergi"],
  },
  {
    id: "e6",
    title: "Teleferik Gün Batımı Turu",
    category: "Eğlence & Aktivite",
    categoryColor: "bg-orange-100 text-orange-700",
    date: "2026-04-05",
    dayShort: "Paz",
    dayNum: "5",
    month: "Nisan",
    time: "17:30 – 21:00",
    location: "Bursa Teleferik İstasyonu",
    district: "Osmangazi",
    image: "https://readdy.ai/api/search-image?query=cable%20car%20gondola%20sunset%20mountain%20Bursa%20Turkey%20golden%20hour%20sky%20city%20lights%20panoramic%20view%20dramatic%20romantic%20landscape&width=600&height=380&seq=ev06&orientation=landscape",
    price: "120 ₺",
    isFree: false,
    isFeatured: false,
    description: "Gün batımında teleferikle Uludağ'a çıkış, panoramik yemek ve gece ışıklarıyla şehre iniş.",
    tags: ["Teleferik", "Manzara", "Gün Batımı"],
  },
  {
    id: "e7",
    title: "Geleneksel El Sanatları Atölyesi",
    category: "Atölye & Workshop",
    categoryColor: "bg-sky-100 text-sky-700",
    date: "2026-04-05",
    dayShort: "Paz",
    dayNum: "5",
    month: "Nisan",
    time: "13:00 – 16:00",
    location: "Hanlar Bölgesi — İpek Atölyesi",
    district: "Osmangazi",
    image: "https://readdy.ai/api/search-image?query=traditional%20craft%20workshop%20silk%20weaving%20handmade%20Ottoman%20artisan%20Bursa%20Turkey%20participants%20learning%20hands-on%20indoor%20cultural%20heritage%20warm%20light&width=600&height=380&seq=ev07&orientation=landscape",
    price: "80 ₺",
    isFree: false,
    isFeatured: false,
    description: "Bursa ipek dokumacılığını öğrenin. 3 saatlik uygulamalı atölye, tüm malzemeler dahil.",
    tags: ["Atölye", "İpek", "El Sanatı"],
  },
  {
    id: "e8",
    title: "Nilüfer Açık Hava Konseri",
    category: "Müzik & Gösteri",
    categoryColor: "bg-pink-100 text-pink-700",
    date: "2026-04-06",
    dayShort: "Pzt",
    dayNum: "6",
    month: "Nisan",
    time: "20:00",
    location: "Nilüfer Belediyesi Amfisi",
    district: "Nilüfer",
    image: "https://readdy.ai/api/search-image?query=outdoor%20open%20air%20concert%20amphitheater%20music%20evening%20Bursa%20Turkey%20audience%20night%20sky%20stage%20lights%20atmosphere%20summer%20event&width=600&height=380&seq=ev08&orientation=landscape",
    price: "Ücretsiz",
    isFree: true,
    isFeatured: false,
    description: "Nilüfer Belediyesi'nin ücretsiz halk konserleri serisi. Bu hafta Türk halk müziği.",
    tags: ["Konser", "Müzik", "Ücretsiz"],
  },
];

export const EVENT_CATEGORIES = [
  "Tümü",
  "Kültür & Tarih",
  "Pazar & Fuar",
  "Yemek & İçecek",
  "Doğa & Spor",
  "Sanat & Kültür",
  "Eğlence & Aktivite",
  "Atölye & Workshop",
  "Müzik & Gösteri",
];
